import { MagnifyingGlass } from '@phosphor-icons/react'
import React, {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react'
import { Button } from '../../../../components/common/Button'
import { Input } from '../../../../components/common/Input'
import { ContextContracts } from '../../../../context/context_contracts'
import api from '../../../../services/api'
import {
  Container,
  FilterContainer,
  Footer,
  Search,
  Table,
  TableCell,
  TableCellEmpty,
  TableHeader,
} from './styles'
import useFilteredData from '../../../../hooks/searchHook'

interface ContractProps {
  id: string
  created_by: string
  updated_at: string
  name: string
  version: string
  text: string
}
interface TableResidentsContractProps {
  openModal: Dispatch<SetStateAction<boolean>>
}
export const TableResidentsContract = ({
  openModal,
}: TableResidentsContractProps) => {
  // const { filteredData, filterData } = useFilteredData('')
  const { startEditing } = useContext(ContextContracts)

  const [search, setSearch] = useState('')
  const [contract, setContract] = useState<ContractProps[]>()

  const handleSubmit = (e) => {
    e.preventDefault()
  }

  const handlerState = (setValue) => {
    setValue((prev) => !prev)
  }

  const { filteredData, filterData } = useFilteredData(contract)

  const handleSearchChange = (e) => {
    setSearch(e.target.value)
    filterData(e.target.value)
  }

  const formatData = (data) => {
    const date = new Date(data)
    const dataFormatada =
      date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()
    return dataFormatada
  }

  useEffect(() => {
    api
      .get('/v1/contract/list')
      .then((response) => {
        setContract(response.data)
      })
      .catch((error) => {
        console.log(error.response.data.statusCode)
      })
  }, [])

  return (
    <>
      <Container>
        <FilterContainer>
          <Search onSubmit={handleSubmit}>
            <span>Pesquisar</span>
            <Input.Root>
              <Input.Wrapper
                borderColor="#CECECE"
                backgroundColor="#F7F7F7"
                outlineColor=""
              >
                <Input.Content
                  id=""
                  onChange={handleSearchChange}
                  type="text"
                  value={search}
                  placeholder="Digite para pesquisar"
                />
                <Input.Icon>
                  <MagnifyingGlass size={16} color="#494949" />
                </Input.Icon>
              </Input.Wrapper>
            </Input.Root>
          </Search>
        </FilterContainer>

        <Table>
          <thead>
            <tr>
              <TableHeader>Nome do contrato</TableHeader>
              <TableHeader>Versão</TableHeader>
              <TableHeader>Data de atualização</TableHeader>
              <TableHeader>Ver detalhes</TableHeader>
            </tr>
          </thead>
          <tbody>
            {contract === undefined || contract.length === 0 ? (
              <tr>
                <TableCellEmpty colSpan={7}>
                  Nenhum dado encontrado
                </TableCellEmpty>
              </tr>
            ) : (
              filteredData?.map((data) => {
                return (
                  <tr key={data.id}>
                    <TableCell>{data.name}</TableCell>
                    <TableCell>{data.version}</TableCell>
                    <TableCell>{formatData(data.updated_at)}</TableCell>
                    <TableCell>
                      <Button.Root
                        onClick={() => {
                          handlerState(openModal)
                          startEditing(data)
                        }}
                        backgroundColor="#00517D"
                        type="button"
                      >
                        <Button.Content title="Ver detalhes" color="#fff" />
                      </Button.Root>
                    </TableCell>
                  </tr>
                )
              })
            )}
          </tbody>
        </Table>
        <Footer>
          Listando {contract?.length !== 0 ? filteredData?.length : '0'}{' '}
          contrato(s)
        </Footer>
      </Container>
    </>
  )
}
